const cancelar_entrega_de_relatorio_final_da_escola = [
  {
    path: "/cancelar-entrega-de-relatorio-final-da-escola",
    name: "cancelar_entrega_de_relatorio_final_da_escola",
    meta: {
      allowedPermissions: ["relatoriofinal_buscar", "relatoriofinal_cancelar"],
      breadCrumb: "Processo de Resultado Final - Relatório Final da Escola",
    },
    component: () =>
      import(
        "@/views/CancelarEntregaDeRelatorioFinalDaEscola/CancelarEntregaDeRelatorioFinalDaEscola.vue"
      ),
  },
];

export { cancelar_entrega_de_relatorio_final_da_escola };
